import { InjectionToken } from "@angular/core";
import { FeatureFlagsState } from "@epdk/util/tokens";
import { environment } from "../../../environment";

export const EP_WWW_CLIENT_FEATURE_FLAGS_STATE = new InjectionToken<FeatureFlagsState>("Ep WWW Client Feature Flags", {
  providedIn: "root",
  factory: (): FeatureFlagsState => {
    return {
      isFlagEnabled(flagName: string): boolean {
        return !!environment[flagName];
      },
    };
  },
});
